import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      marginBottom: theme.spacing(4),
      width: '100%',
    },
    wrapper: {
      color: theme.palette.grey[400],
      display: 'flex',
      alignItems: 'flex-end',
      flexGrow: 1,
      padding: theme.spacing(0, 4, 4),
      maxWidth: 1280,
      margin: '0 auto',
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0, 3, 4),
      },
    },
    disclaimer: {
      background: theme.palette.background.default,
    },
  })
);
